export function extractNodes<T = any>(
  edges: {
    node: T;
  }[],
): T[] {
  return edges.map(edge => edge.node);
}
